import { Link } from 'react-router-dom'
import {ArrowRight, Target, Eye} from 'lucide-react'
import Layout from '@/components/Layout'
import Container from '@/components/ui/Container'
import SectionHeading from '@/components/ui/SectionHeading'
import PageHero from '@/components/PageHero'
import TrustBar from '@/components/TrustBar'
import { mission, vision, coreValues } from '@/data/company'
import { leadership } from '@/data/team'

function About() {
  return (
    <Layout>
      <PageHero
        eyebrow="Sobre a Site Consultoria Tech"
        title="Quinze anos protegendo o que mais importa para nossos clientes"
        description="Somos uma consultoria de tecnologia especializada em segurança eletrônica e conectividade corporativa, unindo engenharia de qualidade, certificações reconhecidas e suporte contínuo."
      >
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link
            to="/contato"
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-cyan-600 px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-cyan-600/20 transition-colors hover:bg-cyan-500"
          >
            Fale com um especialista
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
          <Link
            to="/servicos"
            className="inline-flex items-center justify-center gap-2 rounded-lg border border-white/20 px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10"
          >
            Conhecer soluções
          </Link>
        </div>
      </PageHero>

      <section className="py-20 sm:py-24">
        <Container>
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
            <div className="rounded-2xl border border-slate-100 p-8">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-50 text-cyan-600">
                <Target className="h-5 w-5" aria-hidden="true" />
              </span>
              <h3 className="mt-5 text-lg font-semibold text-slate-900">Nossa Missão</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{mission}</p>
            </div>
            <div className="rounded-2xl border border-slate-100 p-8">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-50 text-cyan-600">
                <Eye className="h-5 w-5" aria-hidden="true" />
              </span>
              <h3 className="mt-5 text-lg font-semibold text-slate-900">Nossa Visão</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{vision}</p>
            </div>
          </div>
        </Container>
      </section>

      <section className="bg-slate-50 py-20 sm:py-24">
        <Container>
          <SectionHeading
            eyebrow="Nossos valores"
            title="Princípios que guiam cada projeto"
            description="Os valores abaixo orientam nossa cultura interna e a forma como conduzimos cada relação com clientes e parceiros."
            align="center"
          />
          <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {coreValues.map((value) => {
              const Icon = value.icon
              return (
                <div key={value.id} className="rounded-2xl bg-white p-6 shadow-sm">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-50 text-cyan-600">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <h3 className="mt-4 text-base font-semibold text-slate-900">{value.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">{value.description}</p>
                </div>
              )
            })}
          </div>
        </Container>
      </section>

      <section className="bg-slate-50 py-20 sm:py-24">
        <Container>
          <SectionHeading
            eyebrow="Liderança"
            title="Conheça quem lidera a nossa empresa"
            description="Uma equipe executiva com décadas de experiência combinada em segurança eletrônica, engenharia e gestão de projetos."
          />
          <div className="mx-auto mt-12 grid max-w-3xl grid-cols-1 gap-6 sm:grid-cols-2">
            {leadership.map(member => (
              <div key={member.id} className="rounded-2xl border border-slate-100 bg-white p-6 text-center">
                <span className={`mx-auto flex h-16 w-16 items-center justify-center rounded-full text-lg font-semibold text-white ${member.color}`}>
                  {member.initials}
                </span>
                <h3 className="mt-4 text-base font-semibold text-slate-900">{member.name}</h3>
                <p className="text-xs font-semibold uppercase tracking-wide text-cyan-600">{member.role}</p>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{member.bio}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      <TrustBar />

      <section className="bg-slate-900 py-16 sm:py-20">
        <Container className="flex flex-col items-center gap-6 text-center">
          <SectionHeading
            title="Quer conhecer nossa equipe de perto?"
            description="Agende uma conversa com nossos consultores e descubra como podemos ajudar a proteger o seu negócio."
            align="center"
            light
          />
          <Link
            to="/contato"
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-cyan-600 px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-cyan-600/20 transition-colors hover:bg-cyan-500"
          >
            Solicitar Consultoria
            <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </Container>
      </section>
    </Layout>
  )
}

export default About
